import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Tabs } from '../root/components/common'
import { useHistory, useParams } from 'react-router-dom'
import { SwapReplacementsMain } from '.'
import { SwapReplacementsArchive } from '.'
const useStyles = makeStyles(() => ({
    wrapper: {
        height: 'calc(100% - 65px)'
    },
    tabs: {
        marginBottom: 15
    }
}))

export default function UserManagement() {
    const classes = useStyles()
    const history = useHistory()
    const { tabName = 'replacements' } = useParams()

    const tabs = {
        replacements: {
            key: 'replacements',
            name: 'Replacements'
        },
        archive: {
            key: 'archive',
            name: 'Archive'
        }
    }

    const onTabChange = tab => {
        history.push(`/swap-replacements/${tab}`)
    }

    return (
        <div className={classes.wrapper}>
            <Tabs
                className={classes.tabs}
                tabs={tabs}
                currentTab={tabName}
                setCurrentTab={onTabChange}
            />
            {tabName === tabs.replacements.key && <SwapReplacementsMain />}
            {tabName === tabs.archive.key && <SwapReplacementsArchive />}
        </div>
    )
}
